import { createIsAfterIgnoreDatePart as d } from "./time-utils.mjs";
import { getTodayDate as c, mergeDateAndTime as r } from "./date-utils.mjs";
const i = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, A = (e) => Math.max(...e.map((n) => {
  var m;
  return (m = i[n.type]) != null ? m : 1;
})), f = (e, n, m) => {
  if (n === i.year)
    return e.startOfYear(m);
  if (n === i.month)
    return e.startOfMonth(m);
  if (n === i.day)
    return e.startOfDay(m);
  let a = m;
  return n < i.minutes && (a = e.setMinutes(a, 0)), n < i.seconds && (a = e.setSeconds(a, 0)), n < i.milliseconds && (a = e.setMilliseconds(a, 0)), a;
}, l = ({
  props: e,
  utils: n,
  granularity: m,
  timezone: a,
  getTodayDate: o
}) => {
  var D;
  let t = o ? o() : f(n, m, c(n, a));
  e.minDate != null && n.isAfterDay(e.minDate, t) && (t = f(n, m, e.minDate)), e.maxDate != null && n.isBeforeDay(e.maxDate, t) && (t = f(n, m, e.maxDate));
  const T = d((D = e.disableIgnoringDatePartForTimeValidation) != null ? D : !1, n);
  return e.minTime != null && T(e.minTime, t) && (t = f(n, m, e.disableIgnoringDatePartForTimeValidation ? e.minTime : r(n, t, e.minTime))), e.maxTime != null && T(t, e.maxTime) && (t = f(n, m, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : r(n, t, e.maxTime))), t;
};
export {
  i as SECTION_TYPE_GRANULARITY,
  l as getDefaultReferenceDate,
  A as getSectionTypeGranularity
};
//# sourceMappingURL=getDefaultReferenceDate.mjs.map
